import { makeStyles, Theme } from '@material-ui/core'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'

export const useSustainabilityWarningDialogStyles = makeStyles((theme: Theme) => ({
    conflictMessage: {
        marginBottom: theme.spacing(2), // 16px
        fontSize: pxToRem(16), // 1.6rem
    },
    parametersList: {
        marginTop: theme.spacing(2), // 16px
        marginBottom: theme.spacing(2), // 16px
        paddingLeft: theme.spacing(2.5), // 20px
        color: theme.palette.common.black,
        fontSize: pxToRem(16), // 1.6rem
        '& li': {
            fontSize: pxToRem(16), // 1.6rem
        },
    },
}))
